(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-grid"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (e) {
  var btn = e.target.closest('.load-more-button');
  if (!btn) return;

  var url = btn.getAttribute('data-load-more-url');
  var sectionId = btn.getAttribute('data-section-id');
  if (!url || btn.disabled) return;

  btn.disabled = true;
  btn.textContent = 'Loading…';

  var sep = url.indexOf('?') !== -1 ? '&' : '?';
  fetch(url + sep + 'section_id=' + sectionId)
    .then(function (res) { return res.text(); })
    .then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newGrid = doc.querySelector('.product-grid--' + sectionId);
      var currentGrid = document.querySelector('.product-grid--' + sectionId);

      if (newGrid && currentGrid) {
        Array.from(newGrid.children).forEach(function (item) {
          currentGrid.appendChild(item);
        });
      }

      var newWrapper = doc.querySelector('.load-more-wrapper');
      var currentWrapper = btn.closest('.load-more-wrapper');

      if (newWrapper && currentWrapper) {
        currentWrapper.replaceWith(newWrapper);
      } else if (currentWrapper) {
        currentWrapper.remove();
      }

      if (window.renderMorRatings) {
        window.renderMorRatings(currentGrid);
      }
    })
    .catch(function () {
      btn.disabled = false;
      btn.textContent = 'Load More';
    });
});
  } catch(e) { console.error(e); }
})();

})();
